import { generateTheme } from '@/app/styles/theme';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
    Experimental_CssVarsProvider as MaterialCssVarsProvider,
    StyledEngineProvider,
    ThemeProvider,
    THEME_ID as MATERIAL_THEME_ID,
    experimental_extendTheme as materialExtendTheme,
} from '@mui/material/styles';
import { ConfigProvider, theme as antdTheme } from 'antd';
import React from 'react';

interface AppProviderProps {
    children: React.ReactNode;
    container: Element | null;
    primaryColor: string;
    materialTheme?: ReturnType<typeof materialExtendTheme>;
}

export default function AppProvider({
    children,
    container,
    primaryColor,
    materialTheme: _materialTheme = materialExtendTheme(),
}: AppProviderProps) {
    const secondaryColor =
        getComputedStyle(document.documentElement)
            .getPropertyValue('--secondary-color')
            .trim() || '#f1c46b';
    const materialThemeWithPrimary = materialExtendTheme({
        colorSchemes: {
            light: {
                palette: {
                    primary: { main: primaryColor, contrastText: '#ffffff' },
                    secondary: { main: secondaryColor, contrastText: '#111928' },
                },
            },
            dark: {
                palette: {
                    primary: { main: primaryColor },
                    secondary: { main: secondaryColor },
                },
            },
        },
    });
    return (
        <StyledEngineProvider injectFirst>
            <CssBaseline />
            <ThemeProvider theme={generateTheme(container)}>
                <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialThemeWithPrimary }}>
                    <JoyCssVarsProvider>
                        <ConfigProvider
                            theme={{
                                algorithm: antdTheme.defaultAlgorithm,
                                token: {
                                    colorPrimary: primaryColor,
                                },
                            }}
                        >
                            <CssBaseline enableColorScheme />
                            {children}
                        </ConfigProvider>
                    </JoyCssVarsProvider>
                </MaterialCssVarsProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
